<template>
  <div class="main">
    <div id="listview">
      <div v-for="item in items" :key="item.text" class="card">
        <div class="card-body">
          <p class="card-text">
            <span>No.{{ item[0] }}</span><span class="pull-right"><span class="status on">{{ item[8] }}</span></span><br>
            {{ item[1] }}<br>
            大人{{ item[2] }}子供{{ item[3] }}<br>
            メモ{{ item[4] }}<br>
            <small class="text-muted pull-right">{{ item[5] }}</small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sx from '../utils/core.js'

export default {
  created() {
    this.$store.state.title = '予約履歴'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'My'
  },
  destroyed() {
    this.$store.state.showBack = false
  },
  data() {
    return {
      items: []
    }
  },
  mounted() {
    sx.showWaiting()
    const that = this

    var params = {
      corpid: 40,
      bucketid: '17',
      token: localStorage.getItem('token')
    }
    var url = that.$store.state.baseurl + '/app/mshelper/fetchReserveDetails'
    sx.request(
      url,
      params,
      function (result) {
        if (result.status === 'ok') {
          that.items = result.data.rows
          sx.hideWaiting()
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
          sx.hideWaiting()
        }
      },
      function () {
        sx.login(
          url,
          params,
          function (result) {
            if (result.status === 'ok') {
              that.items = result.data.rows
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
              that.$router.replace({ name: 'Login' })
            }
          }
        )
      }
    )
  }
}
</script>
<style>
#listview {
  margin: 4px;
}

#listview .card {
  text-align: left;
  margin-top: 4px;
}

small {
  color: #fb6e14;
}

.lead {
  padding-top: 20px;
  text-align: left;
  color: #fb6e14;
}

.main {
  padding: 4px;
}

.status {
  height: 34rpx;
  line-height: 34rpx;
  font-size: 9pt;
  width: 300px;
  text-align: center;
  justify-content: center;
  margin-bottom: 10rpx;
  border-radius: 4px;
  padding: 0 10rpx;
  margin-right: 10rpx;
  background: #CCCCCC;
  color: black;
  margin: 2px;
  padding: 4px;
}

.ing {
  background: #FF9966;
  color: white;
}

.on {
  background: #99CC66;
  color: white;
}

.off {
  background: #CCCCCC;
  color: black;
}
</style>
